<template>
    <span>
        <div class="goods-detail-item" v-if="evaluateGoodsVoList.length">
            <div class="evaluate-title" @click="bindGoAll()">
                <a href="javascript:;" >
                    <span class="title-left">သံုးသပ္ခ်က္ (<em>{{evaluateGoodsTotal}}</em>)</span>
                  <!--<span class="title-right">好评度<em>{{goodsRate}}%</em><i></i></span>-->
                </a>
            </div>
            <!--<div class="evaluate-content">-->
                <!--<div class="evaluate-list-item" v-for="evaItem in evaluateGoodsVoList">-->
                    <!--<div class="evaluate-info">-->
                        <!--<span class="stars">-->
                            <!--<i :class="getClass(evaItem.scores)"></i>-->
                        <!--</span>-->
                        <!--<span class="author">{{evaItem.memberName}}</span>-->
                    <!--</div>-->
                    <!--<div class="evaluate-contect"><a href="javascript:;">{{evaItem.evaluateContent1}}</a>-->
                    <!--</div>-->
                    <!--<div class="evaluate-img" v-if="evaItem.image1FullList.length">-->
                        <!--<a href="javascript:;">-->
                            <!--<ul>-->
                                <!--<li v-for="(itemImage , indexImage) in evaItem.image1FullList"-->
                                    <!--@click="bindShowBigImage(evaItem.evaluateId , 1 , indexImage)"-->
                                    <!--v-if="indexImage <= 3"-->
                                <!--&gt;<img :src="itemImage|$convertImage(240,240)"></li>-->
                            <!--</ul>-->
                        <!--</a>-->
                    <!--</div>-->

                <!--</div>-->
            <!--</div>-->
          <!--<div class="evaluate-bottom">-->
          <!--<a class="evaluate-btn" href="javascript:;" @click="bindGoAll()">သုံးသပ္ခ်က္မ်ား(<em>{{evaluateGoodsTotal}}</em>)</a>-->
          <!--</div>-->
        </div>


        <div class="goods-detail-item" v-if="!evaluateGoodsVoList.length">
            <div class="detail-item" @click="bindGoAll()">
                <a href="javascript:;">
                    <div class="item-name-right">
                        <p class="no-evaluate-content" data-name="评价">သံုးသပ္ခ်က္
                          <!--<span class="no-evaluate">( ကုႏၼ႐ြိ၊ဝယ္်ပီးေနာက္သံုးသပၡ္က္ေရးပါ )</span>-->
                        </p>
                    </div>
                    <div class="item-more-right"></div>
                </a>
            </div>
        </div>
      <!-- 移动到body -->
        <div :class="['nctouch-bigimg-layout', {hide:!showLayer}]" ref="layer"  @touchmove="excludeTouch">
            <div class="close" @click="bindHideBigImage()"></div>
            <div class="pic-box" ref="evalSwipe">
                <ul>
                    <li v-for="itemImage in currentImageList"
                        :style="{'background-image': 'url('+ itemImage +')'}"></li>
                </ul>
            </div>
            <div class="nctouch-bigimg-turn">
                <ul>
                    <li :class="{cur:( index-1) == showBigImageEvalIndex}"
                        v-for="index in currentImageList.length"></li>
                </ul>
            </div>
        </div>
        </span>
</template>
<script>
  //    var ApiUrl = "https://my.zegobird.com:11101/api";

  /**
   * 商品评论
   */
  var urlEva = ApiUrl + '/goods/evaluate/',
    swipteInstance ,
    dev = true
  ;
  export default {
    props: {

      evaluateGoodsVoList:{
        validator: function (value) {
          var _type = $.type(value) == 'array'
          _type || console.log("goods-eavaluate->props->goodsRate is not array")
          return _type
        }
      },
      evaluateGoodsTotal:{
        validator: function (value) {
          var _type = $.type(value) == 'number'
          _type || console.log("goods-eavaluate->props->goodsRate is not number")
          return _type
        }
      },
      goodsRate:{
        validator: function (value) {
          var _type = $.type(value) == 'number'
          _type || console.log("goods-eavaluate->props->goodsRate is not number")
          return _type
        }
      }
    },
    /*
     * 自身数据,一定要一个function
     */
    data() {
      return {
        //显示评论大图
        showBigImageEvalId: 0,
        showBigImageEvalIndex: 0,
        //
        showBigImageEvalType: 1,
        //显示弹出层
        showLayer: false ,

        first:true
      }
    },
    computed: {
      currentImageList: function () {
        var _id = this.showBigImageEvalId,
          _type = this.showBigImageEvalType,
          _index = this.showBigImageEvalIndex ,
          _result = []

        ;

        this.evaluateGoodsVoList.forEach(function (item) {
          if (item.evaluateId == _id) {
            _result =  item["image" + _type + "FullList"]
          }
        })
        return _result;
      }
    },
    mounted() {

      var $layer = this.$refs.layer;
      var $body = document.getElementsByTagName("body")[0];
      $body.appendChild($layer);
    },
    /**
     * 自定义方法
     */
    methods: {
      //去除无关的touch事件
      excludeTouch:function(event){
        event.preventDefault();
        return false ;
      },


      //小星星的样式
      getClass: function (value) {
        return "star" + value
      },
      //点击参看更多事件
      bindGoAll: function () {

        this.$emit('goalleval')
      },
      //点击显示大图
      bindShowBigImage: function (evaluateId, type, index) {
        var self = this
        this.showBigImageEvalId = evaluateId
        this.showBigImageEvalType = type
        this.showBigImageEvalIndex = index
        this.showLayer = true
        this.$nextTick(function () {


          swipteInstance = Swipe(self.$refs.evalSwipe, {
            startSlide: index,
            continuous: false,
            stopPropagation: true,
            disableScroll:true ,
            callback: function (sIndex, element) {
              self.showBigImageEvalIndex = sIndex
            }
          });

        })
      },
      //点击隐藏大图
      bindHideBigImage: function () {

        this.showBigImageEvalId = 0
        this.showBigImageEvalType = 1
        this.showBigImageEvalIndex = 0
        swipteInstance && swipteInstance.kill()
        this.showLayer = false
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/goods-evaluate/goods-evaluate.vue